import { Injectable } from '@angular/core';
import { ProductsStore } from './products.store';
import { take } from 'rxjs/operators';
import { Products } from '../../../../models/Products';
import { Observable } from 'rxjs';
import { ConstantsStore } from '../../constants.store';
import { ApiService } from '../../api-service';
import { Service } from '../../../../models/acquista-servizi-models/service';
import { ShopPortfolio } from '../../../../models/acquista-servizi-models/shop-portfolio';
import { Subscription } from '../../../../models/acquista-servizi-models/subscription';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ProductsService {
  constructor(
    private store: ProductsStore,
    private constants: ConstantsStore,
    private apiService: ApiService,
    private http: HttpClient
  ) {}

  getAllProducts() {
    return new Observable((observer) => {
      this.apiGet<Products>('GetAll').subscribe(
        (products) => {
          this.store.loadAllProducts(products);
          // console.log('ALL PRODUCTS', products);
          observer.next(products);
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }

  public getAllProductsPromise(): Promise<Products[]> {
    return new Promise((resolve, reject) => {
      this.http.get(`${this.constants.acquistaServiziUrl}/GetAll`)
      .toPromise()
      .then(
        (products: Products[]) => resolve(products),
        (error: any) => reject(error)
      );
    });
  }

  getFilteredProducts(name: string) {
    return new Observable((observer) => {
      this.apiGet<Products>('GetByName' + '/' + name).subscribe(
        (products) => {
          this.store.loadAllProducts(products);
          observer.next();
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }

  getAbbonamenti() {
    return new Observable((observer) => {
      this.apiGet<Subscription>('Abbonamenti').subscribe(
        (abbonamenti) => {
          this.store.loadSubscriptions(abbonamenti);
          observer.next();
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }

  getServizi() {
    return new Observable((observer) => {
      this.apiGet<Service>('Servizi').subscribe(
        (servizi) => {
          this.store.loadServices(servizi);
          observer.next();
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }

  getPortafogli() {
    return new Observable((observer) => {
      this.apiGet<ShopPortfolio>('Portafogli').subscribe(
        (portafogli) => {
          this.store.loadPortfolios(portafogli);
          observer.next();
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }

  getById(id: number) {
    return new Observable((observer) => {
      this.apiService
        .getTableRecordNoCache(
          this.constants.acquistaServiziUrl + '/GetById/' + id
        )
        .subscribe(
          (res: Products) => {
            this.store.product = res;
            observer.next();
          },
          (error) => {
            console.log('Error in ProductsService: ', error);
            observer.error(error);
          }
        );
    });
  }

  getAutoCompleteValues() {
    if (!this.store.autocompleteValues) {
      return new Promise((resolve, reject) => {
        this.apiService
          .get<string[]>(this.constants.autocompleteProductsUrl)
          .toPromise()
          .then((res: string[]) => {
            this.store.autocompleteValues = res;
            resolve(true);
          })
          .catch((err) => {
            reject(err);
          });
      });
    }
  }

  addNewProduct(data: Products) {
    return new Observable((observer) => {
      this.apiPost(data).subscribe(
        () => {
          this.getAllProducts().subscribe();
          observer.next();
        },
        (error) => {
          console.log('Error in ProductsService: ', error);
          observer.error(error);
        }
      );
    });
  }

  updateProduct(productToUpdate: Products) {
    return new Observable((observer) => {
      this.apiPatch(productToUpdate)
        .pipe(take(1))
        .subscribe(
          (productUpdated) => {
            this.store.product = productUpdated;
            observer.next();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }

  deleteProduct(id: number) {
    return new Observable((observer) => {
      this.apiDelete(id).subscribe(
        () => {
          this.getAllProducts().subscribe();
          observer.next();
        },
        (error) => {
          console.log('Error in ProductsService: ', error);
          observer.error(error);
        }
      );
    });
  }


  private apiGet<T>(subPath: string) {
    return this.apiService.getProductsRecordsNoCacheBasic<T>(
      `${this.constants.acquistaServiziUrl}/${subPath}`
    );
  }
  private apiPost<T>(toAdd: any) {
    return this.apiService.post<Products>(
      this.constants.acquistaServiziUrl,
      toAdd
    );
  }
  private apiPatch(productToUpdate: Products) {
    return this.apiService.patch<Products>(
      this.constants.acquistaServiziUrl + '/Update',
      productToUpdate
    );
  }
  private apiPatchCredit<T>(obj: T) {
    return this.apiService.patch<T>(
      this.constants.acquistaServiziUrl + '/DeleteCrediti',
      obj
    );
  }
  private apiPut(productToUpdate: Products) {
    return this.apiService.put<Products>(
      this.constants.acquistaServiziUrl,
      productToUpdate
    );
  }
  private apiDelete<T>(id: number) {
    return this.apiService.delete(this.constants.acquistaServiziUrl, id);
  }


  eliminaCrediti(id: number) {
    return new Observable((observer) => {
      this.apiPatchCredit<number>(id).subscribe(
        () => {
          //  this.getById(id);
          this.getAllProducts().subscribe();
          observer.next();
        },
        (error) => {
          console.log('Error in ProductsService: ', error);
          observer.error(error);
        }
      );
    });
  }

}
